import { useEffect, useState } from 'react';
import type { UseEmblaCarouselType } from 'embla-carousel-react';

type EmblaApi = UseEmblaCarouselType[1];

interface CarouselScrollState {
    canScrollPrev: boolean;
    canScrollNext: boolean;
}

const NO_SCROLL: CarouselScrollState = { canScrollPrev: false, canScrollNext: false };

export function useCarouselScrollState(emblaApi: EmblaApi): CarouselScrollState {
    const [scrollState, setScrollState] = useState<CarouselScrollState>(NO_SCROLL);

    useEffect(() => {
        if (!emblaApi) return;

        const syncScrollState = () =>
            setScrollState({
                canScrollPrev: emblaApi.canScrollPrev(),
                canScrollNext: emblaApi.canScrollNext(),
            });

        syncScrollState();
        emblaApi.on('select', syncScrollState).on('reInit', syncScrollState);

        return () => {
            emblaApi.off('select', syncScrollState).off('reInit', syncScrollState);
        };
    }, [emblaApi]);

    return scrollState;
}
